<div class="container">
  <div class="container success-box shadow mt-lg-5 mt-4">
    <h5 class="text-success text-center pt-3">{{ 'purchase.success.label' | translate }}</h5>
    <hr />
    <div class="row">
      <div class="col-lg-6 col-12 mb-3 nav-btn-col">
        <a class="btn btn-primary confirm-btn fw-bold font-size-14" [routerLink]="['/rewards']">{{
          'back.to.rewards.btn' | translate
        }}</a>
      </div>
      <div class="col-lg-6 col-12 text-end mb-3 nav-btn-col">
        <a class="btn btn-wallet confirm-btn fw-bold font-size-14" [routerLink]="['/rewards/wallet']">{{
          'back.to.wallet' | translate
        }}</a>
      </div>
    </div>
  </div>
</div>
